import React, { useEffect, useState } from 'react'
import { Box } from '@mui/system'
import styled from '@emotion/styled' 
import { Autocomplete, Avatar, Button, Checkbox, Divider, FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from '../../api/authApi'
const StyledForm=styled("form")(({theme})=>({
  padding:'20px',
  display:'flex',
  flexDirection:'column',
  gap:'20px',
}))
const BackGround=styled(Box)(({theme})=>({
   display:'flex',
   justifyContent:'center',
   alignItems:'center',
   padding:'30px',
   height:{
    xs:'100%',
    sm:'100vh',
  },
   width:'98vw',  
   background:theme.palette.secondary.lighter,
}))
const SignInCard=styled(Box)(({theme})=>({
    minWidth:'80%',
    background:theme.palette.background.default,
    boxShadow: `0px 0px 7px ${theme.palette.background.shadow}`,
    borderRadius:'10px',
    padding:'10px',
}))
const LogoContainer = styled('span')(({theme})=>({
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    justifyContent:'center',
    cursor:'pointer',
    span: {
        fontSize: '34px',
        fontWeight: '600',
    },
    marginLeft:'10px',
    paddingBottom:'40px',
}))
const StyledTypography = styled(Box)(({theme})=>({
   display:'flex',
   width:'100%',
   justifyContent:'flex-end',
   textDecoration:'underline',
   paddingRight:'10px',
   cursor:'pointer',
   color:theme.palette.third.main,
   "&:hover":{
     color:theme.palette.secondary.main,

   }
}))
const Names = styled(Box)(({theme})=>({
   display:'flex',
   width:'100%',
   justifyContent:'space-between',
   "& TextField":{
    width:'30%',
   }
}))
const Header=styled(Box)(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    padding:"15px",
    color: theme.palette.third.main,
    fontWeight: '400',
    fontSize: '20px',
}))
const StyledLabel=styled('label')(({theme})=>({
    color: theme.palette.third.main,
    fontWeight: '400',
    fontSize: '15px',
    lineHeight: '20px',
}))

export default function ConfirmSignUp() {
  const navigate=useNavigate()
  //  async function getData(){
  //       const res = await api.get(`info/${__t}`);
  //   }
    const [rank,setRank]=useState([])
    const [status,setStatus]=useState([])
    const [department,setDepartment]=useState([])

    useEffect(()=>{
      let isMounted=true;
      const controller=new AbortController();
      const getData=async ()=>{
        try{
          const response=await api.get(`signupPendingInfo`,{
            signal:controller.signal
          })
          isMounted && setRank(response.data?.rank)
          isMounted && setStatus(response.data?.status)
          isMounted && setDepartment(response.data?.department)

        }
        catch(err){
          console.error(err)
        }
      }
      getData();
      return ()=>{
        isMounted=false;
        controller.abort()
      }
        },[])
    
    const [agree, setAgree]=useState(false);
    // console.log(status,rank,department);
    const validationSchema = yup.object({
      email: yup.string()
        .email("Enter the correct Email")
        .required("Email is required"),
      fname: yup.string()
        .required("First Name is required"),
      mname: yup.string()
        .required("Middle Name is required"),
      lname: yup.string()
        .required("Last Name is required"),
      mobile: yup.string()
        .required("Phone Number is required"),
      password: yup.string()
        .matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/, 'Password must at least be 8 characters containing one uppercase and one lowercase letter and a digit')
        .required("Password is required"),
      cpassword: yup
        .string("Confirm your New Password")
        .oneOf([yup.ref('password'),null],"Passwords must match"),
       rank: yup
        .string("Choose your Academic Rank")
        .required("Research Role is required"),
      status: yup
      .string("Choose your Employment Status")
      .required("Employment Status is required"),
      department: yup
      .string("Choose your Department")
      .required("Department is required"),
    });
    const formik = useFormik({
        enableReinitialize:true,
        initialValues: {
          email:'',
          fname:'',
          mname:'',
          lname:'',
          mobile:'',
          password:'',
          cpassword:'',
          rank:'',
          status:'',
          department:null
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
          // console.log(values)
        const result={
          department:values.department,
          rank_id:values.rank,
          status_id:values.status,
          email:values.email,
          first_name:values.fname,
          middle_name:values.mname,
          last_name:values.lname,
          password:values.password,
          mobile:values.mobile,
        }
          api
          .post("/signupPending", result)
          .then((response) => {
           response.data?navigate('/success'):alert("There seem to be a problem with the registration process please try again.")
          })
        },
      });
      // console.log(formik.values)
    
      return (
        <BackGround>
            <SignInCard>
                <LogoContainer >
                    <Avatar src="/images/aastulogo.png" sx={{ width: 40, height: 40 }} />
                    <span>AsLMS</span>
                </LogoContainer>
                <Divider/>
                <Header>
                {`Staff Account Sign up Form`}
                </Header>
                <Divider/>
                <StyledForm onSubmit={formik.handleSubmit}>
                  <Names>
                  <TextField
                    sx={{width:'30%'}}
                    label="First Name"
                    id="fname"
                    name="fname"
                    onBlur={formik.handleBlur}
                    value={formik.values.fname}
                    onChange={formik.handleChange}
                    error={formik.errors.fname && formik.touched.fname }
                    helperText={formik.touched.fname && formik.errors.fname}
                    variant="standard"
                  />
                <TextField
                    sx={{width:'30%'}}
                    label="Middle Name"
                    id="mname"
                    name="mname"
                    onBlur={formik.handleBlur}

                    value={formik.values.mname}
                    onChange={formik.handleChange}
                        error={formik.errors.mname && formik.touched.mname }
                        helperText={formik.touched.mname && formik.errors.mname}
                    variant="standard"
                  />
                  <TextField
                    sx={{width:'30%'}}
                    label="Last Name"
                    id="lname"
                    name="lname"
                    onBlur={formik.handleBlur}

                    value={formik.values.lname}
                    onChange={formik.handleChange}
                    error={formik.errors.lname && formik.touched.lname }
                    helperText={formik.touched.lname && formik.errors.lname}
                    variant="standard"
                  />
                  </Names>
                  <TextField
                    fullWidth
                    type="email"
                    label="Email"
                    id="email"
                    name="email"
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.errors.email && formik.touched.email }
                    helperText={formik.touched.email && formik.errors.email}
                    variant="standard"
                  />
                  <TextField
                      fullWidth
                      label="Phone Number"
                      id="mobile"
                      name="mobile"
                      value={formik.values.mobile}
                    onBlur={formik.handleBlur}

                      onChange={formik.handleChange}
                      error={formik.errors.mobile && formik.touched.mobile }
                      helperText={formik.touched.mobile && formik.errors.mobile}
                      variant="standard"
                    />
                <TextField
                    fullWidth
                    type="password"
                    label="Password"
                    onBlur={formik.handleBlur}

                    id="password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={formik.errors.password && formik.touched.password }
                    helperText={formik.touched.password && formik.errors.password}
                    variant="standard"
                  />
                <TextField
                    fullWidth
                    type="password"
                    label="Confirm Password"
                    onBlur={formik.handleBlur}

                    id="cpassword"
                    name="cpassword"
                    value={formik.values.cpassword}
                    onChange={formik.handleChange}
                    error={formik.errors.cpassword && formik.touched.cpassword }
                    helperText={formik.touched.cpassword && formik.errors.cpassword}
                    variant="standard"
                  />
                  <StyledLabel>
                      Academic Rank
                  </StyledLabel>
                  <RadioGroup
                      row
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="rank"
                      id="rank"
                      onBlur={formik.handleBlur}
                      value={formik.values.rank}
                      onChange={formik.handleChange}
                      sx={{marginLeft:'2%'}}
                  >
                    {
                    rank.map((ran)=>{
                                    return ( <FormControlLabel value={ran.id} control={<Radio color='secondary' />} label={ran.academic_type} />)
                                })
                  }
                  </RadioGroup>
                  <StyledLabel>
                      Employment Status
                  </StyledLabel>
                  <RadioGroup
                      row
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="status"
                      id="status"
                      onBlur={formik.handleBlur}
                      value={formik.values.status}
                      onChange={formik.handleChange}
                      sx={{marginLeft:'2%'}}

                  >
                    {
                    status.map((s)=>{
                                    return ( <FormControlLabel value={s.id} control={<Radio color='secondary' />} label={s.type} />)
                                })
                  }
                  </RadioGroup>
                  <StyledLabel>
                     Choose Department
                  </StyledLabel>
                  <RadioGroup
                      row
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="department"
                      id="department"
                      onBlur={formik.handleBlur}
                      value={formik.values.department}
                      onChange={formik.handleChange}
                      sx={{marginLeft:'2%', display:'flex',flexDirection:'column'}}
                  >
                   {
                    department.map((d)=>{
                                    return ( <FormControlLabel value={d.id} control={<Radio color='secondary' />} label={d.name} />)
                                })
                  }
                  </RadioGroup>
                <FormControlLabel control={<Checkbox
                    color='secondary' 
                    value={agree}
                    onChange={()=>setAgree(!agree)}
                    sx={{color:'third.main', }}
                    />} 
                    label="I agree to the terms and conditions" 
            />
                  <Button
                  disabled={!agree || formik.errors.fname 
                                  || formik.errors.mname
                                  || formik.errors.lname 
                                  || formik.errors.mobile
                                  || formik.errors.password 
                                  || formik.errors.cpassword
                  }
                  type="submit"
                  size="large"
                  sx={{
                      bgcolor:'secondary.main',
                      fontWeight: 400,
                      color:'#fff',
                      "&:hover":{
                      bgcolor:'secondary.hover',}, } }
                  >
                    Sign In
                  </Button>
                </StyledForm>
            </SignInCard>
        </BackGround>
      )
    }
